module.exports = __webpack_public_path__ + "static/arha-081235e5f4ba74c0e06b7e9a57201b5b.svg";